
<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

        <div class="modal-body">
            <h4 class="fw-bold">{{ title }}</h4>
            <hr>
            <h5>{{ subtitle }}</h5>
            @if (thumbnailUrl) {
                <img src="{{ thumbnailUrl }}" alt="{{ title }}" fill="">
            }
            @else {
                <svg width="95px" height="95px" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="120" height="120" fill="#EFF1F3"></rect> <path fill-rule="evenodd" clip-rule="evenodd" d="M33.2503 38.4816C33.2603 37.0472 34.4199 35.8864 35.8543 35.875H83.1463C84.5848 35.875 85.7503 37.0431 85.7503 38.4816V80.5184C85.7403 81.9528 84.5807 83.1136 83.1463 83.125H35.8543C34.4158 83.1236 33.2503 81.957 33.2503 80.5184V38.4816ZM80.5006 41.1251H38.5006V77.8751L62.8921 53.4783C63.9172 52.4536 65.5788 52.4536 66.6039 53.4783L80.5006 67.4013V41.1251ZM43.75 51.6249C43.75 54.5244 46.1005 56.8749 49 56.8749C51.8995 56.8749 54.25 54.5244 54.25 51.6249C54.25 48.7254 51.8995 46.3749 49 46.3749C46.1005 46.3749 43.75 48.7254 43.75 51.6249Z" fill="#687787"></path> </g></svg>
            }

            <div class="row mt-4">
                <div class="col-4"><b>Duration</b></div>
                <div class="col-8">{{ duration }}</div>
            </div>
            <div class="row mt-2">
                <div class="col-4"><b>Description</b></div>
                <div class="col-8">{{ description }}</div>
            </div>

            <hr class="mt-5">
            <div class="text-center">
                <button style="border-radius: 25px" type="button" class="btn btn-lg btn-success me-2 fw-bold" (click)="activeModal.close()">
                    Close
                </button>
            </div>

        </div>
    </div>
</div>
